import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  INPUT_GROUP_CLASS,
  TInputGroupProps,
} from "@/ui/components/form/InputGroup/InputGroup.config";

export const InputGroup: FC<TInputGroupProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="InputGroup"
    className={cn(INPUT_GROUP_CLASS, className)}
  >
    { children }
  </div>
);

InputGroup.displayName = "InputGroup";
